<mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
<div class="modal-tabela-preco container-fluid d-flex border-bottom">
  <div class="row mr-auto">
    <div class="col-md-12">
      <h4>Tabela Preço - {{idTabela}}</h4>
    </div>
  </div>
</div>
<mat-card-content>
    <table mat-table [dataSource]="grid" class="table-responsive container-fluid no-padding">      

      <ng-container matColumnDef="origem">
        <th mat-header-cell *matHeaderCellDef >
          Origem
        </th>
        <td mat-cell *matCellDef="let element"> {{ element?.cidadeOrigem }} - {{element?.ufOrigem}} - {{element?.cepOrigem}} </td>
      </ng-container>

      <ng-container matColumnDef="destino">
        <th mat-header-cell *matHeaderCellDef >
          Destino
        </th>
        <td mat-cell *matCellDef="let element">  {{ element?.cidadeDestino }} - {{element?.ufDestino}} - {{element?.cepDestino}} </td>
      </ng-container>

      <ng-container matColumnDef="regiao">
        <th mat-header-cell *matHeaderCellDef >
          Região
        </th>
        <td mat-cell *matCellDef="let element"> {{ element?.regiao }} </td>
      </ng-container>

      <ng-container matColumnDef="pid">
        <th mat-header-cell *matHeaderCellDef >PID</th>
        <td mat-cell *matCellDef="let element">{{ element?.pid }}
        </td>
      </ng-container>

      <ng-container matColumnDef="valorFrete">
        <th mat-header-cell *matHeaderCellDef >Valor Frete</th>
        <td mat-cell *matCellDef="let element">{{ element?.valorFrete | currency : 'BRL'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="taxaAdValorem">
        <th mat-header-cell *matHeaderCellDef >Taxa Advalorem</th>
        <td mat-cell *matCellDef="let element">{{ element?.taxaAdValorem }}
        </td>
      </ng-container>

      <ng-container matColumnDef="taxaGris">
        <th mat-header-cell *matHeaderCellDef >Taxa Gris</th>
        <td mat-cell *matCellDef="let element">{{ element?.taxaGris }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
</mat-card-content>

<div class="modal-actions" mat-dialog-actions align="end">
  <button mat-flat-button color="info" mat-dialog-close="cancel">
    Fechar
  </button>
</div>